import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import { useDrag, useDrop } from 'react-dnd';
import ItemTypes from './ItemTypes';
const style = {
  border: '1px dashed gray',
  borderRadius: '23px',
  padding: '0.5rem 1rem',
  marginBottom: '.5rem',
  cursor: 'move',
  display: 'flex',
  justifyContent: 'space-between'
};

const PuzzleCard = ({ index, card, moveCard, toggleActive, disabled=false }) => {

  const ref = useRef(null)
  const [{ isOver }, drop] = useDrop({
    accept: ItemTypes.CARD,
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
    }),
  })
  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.CARD, index },
    canDrag: monitor => {
      return card.active !== null ? card.active : false
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0.8 : isOver ? 0 : 1
  drag(drop(ref))

  const toggleItem = () => {
    toggleActive(index);
  };

  return (
    <div ref={ref} style={{ ...style, opacity }}>
      {card.application && card.application.description}
      <Form.Check
        type="switch"
        id={"check" + index}
        label=""
        checked={card.active !== null ? card.active : false}
        onChange={() => toggleItem()}
        disabled={disabled}
      />
    </div>
  )
}
export default PuzzleCard
